/**
 * PriorityChip — small monospace badge for URGENT/HIGH/MEDIUM/LOW.
 *
 * Mockup class: .prio + .prio-{urgent,high,medium,low}.
 * Priority levels map: 1=URGENT, 2=HIGH, 3=MEDIUM, 4=LOW
 * (matching the project's existing priority numeric convention).
 */

type PriorityLevel = "urgent" | "high" | "medium" | "low";

const LEVEL_FROM_NUMBER: Record<number, PriorityLevel> = {
  1: "urgent",
  2: "high",
  3: "medium",
  4: "low",
};

interface PriorityChipProps {
  /** Priority as number (1-4) or named level */
  level: number | PriorityLevel;
}

export function PriorityChip({ level }: PriorityChipProps) {
  const lvl =
    typeof level === "number" ? LEVEL_FROM_NUMBER[level] || "medium" : level;
  return <span className={`prio prio-${lvl}`}>{lvl.toUpperCase()}</span>;
}
